import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';
import { StickyCopyExtension } from 'common/StickyCopyExtension/StickyCopyExtension';
import {
  CellLayout,
  CellLayoutRow,
  CellLayoutPrimaryTypography,
  CellLayoutSecondaryTypography,
} from './CellLayout';
import { TableTooltip } from 'src/common/components/Tooltip/TableTooltip';

const IconCellRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4),
  width: '100%',
}));

const IconBox = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

const TextsBox = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: `calc(100% - ${theme.spacing(24)})`,
}));

export type IconCellProps = {
  icon?: React.ReactNode;
  primaryText?: string;
  secondaryText?: string;
  isSecondaryLoading?: boolean;
};

const IconCellSuspense = ({
  loading,
  children,
}: {
  loading: boolean;
  children: React.ReactNode;
}) => {
  return loading ? (
    <CellLayoutRow>
      <Skeleton height={18} />
    </CellLayoutRow>
  ) : (
    children
  );
};

export const IconCell = ({
  icon,
  primaryText,
  secondaryText,
  isSecondaryLoading,
}: IconCellProps) => {
  return (
    <CellLayout>
      <IconCellRoot>
        <IconBox>{icon}</IconBox>
        <TextsBox>
          <CellLayoutRow>
            <StickyCopyExtension value={primaryText || ''}>
              <TableTooltip value={primaryText || ''}>
                <CellLayoutPrimaryTypography>{primaryText || '-'}</CellLayoutPrimaryTypography>
              </TableTooltip>
            </StickyCopyExtension>
          </CellLayoutRow>
          <IconCellSuspense loading={!!isSecondaryLoading}>
            {secondaryText === undefined ? null : (
              <CellLayoutRow>
                <StickyCopyExtension value={secondaryText}>
                  <TableTooltip value={secondaryText || ''}>
                    <CellLayoutSecondaryTypography>
                      {secondaryText || '-'}
                    </CellLayoutSecondaryTypography>
                  </TableTooltip>
                </StickyCopyExtension>
              </CellLayoutRow>
            )}
          </IconCellSuspense>
        </TextsBox>
      </IconCellRoot>
    </CellLayout>
  );
};
